import React, {Component, Fragment} from 'react';
import {Query} from 'react-apollo';
import ArticleWrapper from 'components/ArticleWrapper/ArticleWrapper';
import ArticleSchema from './ArticleSchema';
import PageMeta from 'components/PageMeta/PageMeta';
import AnchorsSection from 'components/AnchorsSection/AnchorsSection';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Hero from 'components/ArticleHero/ArticleHero';
import SocialShare from 'components/SocialShare/SocialShare';
import RichText from 'components/RichText/RichText';
import RelatedArticles from 'components/RelatedArticles/RelatedArticles';
import SeoLinkpile from 'components/SeoLinkpile/SeoLinkpile';
import HttpError from 'components/HttpError';
import {reach} from '@hapi/hoek';
import {query} from './articleQuery';

import {getBreadcrumbs, categoryLookup} from 'utils/utils';
import {HomeRouteContext} from 'utils/context';
import withQuery from 'utils/withQuery';

function getIsDevice(isMobile, systemData) {
    return isMobile || systemData.isMobile || systemData.isTablet;
}

const LoadedArticle = (props) => {
    const {
        allCategories,
        translations,
        systemData: {siteName, hostname, basePath, domain},
        systemData,
        response,
        homeRoute,
        location,
        isMobile,
        socialShares,
        categoryId,
        slug,
    } = props;
    const isDevice = getIsDevice(isMobile, systemData);
    const article = reach(response, 'data.articles.items.0');

    if (!article) {
        return <HttpError statusCode={404} message="Not Found" />;
    }

    const {
        richTextContent,
        headline,
        heroFile,
        heroVideo,
        metaDescription,
    } = article;

    const parentCategory = categoryLookup(allCategories, 'sys.id', categoryId);
    const crumbs = getBreadcrumbs(
        allCategories,
        {
            name: parentCategory.partition ? null : translations.home,
            url: homeRoute,
        },
        parentCategory,
        article,
    );
    const canonical = `https://${hostname}${basePath}${
        homeRoute + parentCategory.path
    }/${article.slug}`;
    const sections = richTextContent.json.content.filter((type) => {
        return type.nodeType === 'heading-2' || type.nodeType === 'heading-3';
    });

    const seoLinkpilePath = `${homeRoute}${parentCategory.path}/${article.slug}`;

    const linkpileProps = {
        site: siteName,
        canonicalLink: seoLinkpilePath,
        isMobile: isMobile || systemData.isMobile,
    };

    return (
        <Fragment>
            <ArticleWrapper>
                <PageMeta
                    {...article}
                    {...{systemData}}
                    canonical={canonical}
                    isArticle="true"
                />
                <ArticleSchema
                    headline={headline}
                    {...article}
                    {...{systemData}}
                    canonical={canonical}
                />
                <Hero
                    title={headline}
                    image={heroFile}
                    video={heroVideo}
                    renderedCrumbs={
                        <Breadcrumbs
                            crumbs={crumbs}
                            hostname={systemData.hostname}
                        />
                    }
                />
                <meta itemProp="description" content={metaDescription} />
                <SocialShare
                    socialShares={socialShares}
                    copiedText={translations.copyLink}
                />
                <AnchorsSection
                    sections={sections}
                    currentHash={location.hash}
                />
                <RichText
                    {...{
                        richTextContent,
                        translations,
                        homeRoute,
                        isDevice,
                        domain,
                    }}
                />
                <RelatedArticles
                    title={translations.exploreArticles}
                    category={categoryId}
                    slug={`/${slug}`}
                />
            </ArticleWrapper>
            <SeoLinkpile {...linkpileProps} />
        </Fragment>
    );
};

const ArticleWithLoading = withQuery(LoadedArticle);

export default class ArticleContainer extends Component {
    static contextType = HomeRouteContext;
    render() {
        const {slug, systemData, categoryId, preview} = this.props;
        const articleSlug = slug.split('/').pop();
        const homeRoute = this.context;
        const variables = {
            sitename: systemData.siteName,
            parentId: categoryId,
            slug: articleSlug,
            preview,
        };

        return (
            <Query {...{query, variables}}>
                {(response) => {
                    return (
                        <ArticleWithLoading
                            {...{...this.props, response, homeRoute}}
                        />
                    );
                }}
            </Query>
        );
    }
}
